const btns = {
  update: (h, params, vm) => {
    return h('Button', {
      props: {
        type: 'primary',
        size: 'small',
        icon: 'ios-create-outline'
      },
      style: {
        marginRight: '5px'
      },
      on: {
        click: () => {
          vm.$emit('on-update', params)
        }
      }
    }, '编辑')
  },
  reset: (h, params, vm) => {
    return h('Button', {
      props: {
        type: 'primary',
        size: 'small',
        icon: 'md-refresh'
      },
      style: {
        marginRight: '5px'
      },
      on: {
        click: () => {
          vm.$emit('on-reset', params)
        }
      }
    }, '重置密码')
  },
  detail: (h, params, vm) => {
    return h('Button', {
      props: {
        type: 'primary',
        size: 'small',
        icon: 'md-document'
      },
      style: {
        marginRight: '5px'
      },
      on: {
        click: () => {
          vm.$emit('on-detail', params)
        }
      }
    }, '详情')
  }
}

export default btns
